import "../App.css";
import React, { useState } from "react";
import {
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
} from "@mui/material";
export default function Contact() {
  const [fullName, setFullName] = useState("");
  const [subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [fullNameError, setFullNameError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [messageError, setMessageError] = useState("");

  const validateForm = () => {
    let isValid = true;

    if (fullName.length < 3) {
      setFullNameError("Minimum number of characters is 3");
      isValid = false;
    } else {
      setFullNameError("");
    }

    if (subject.length < 3) {
      setSubjectError("Minimum number of characters is 3");
      isValid = false;
    } else {
      setSubjectError("");
    }

    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    if (!email.match(emailPattern)) {
      setEmailError("Must be a valid email address");
      isValid = false;
    } else {
      setEmailError("");
    }

    if (message.length < 3) {
      setMessageError("Minimum number of characters is 3");
      isValid = false;
    } else {
      setMessageError("");
    }
    return isValid;
  };

  const onFullNameChange = (event) => {
    setFullName(event.target.value);
  };

  const onSubjectChange = (event) => {
    setSubject(event.target.value);
  };

  const onEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const onMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const onFormSubmit = (event) => {
    event.preventDefault();

    if (validateForm()) {
      const formInput = {
        fullName,
        email,
        subject,
        message,
      };
      console.log("Submitted Form Is :", formInput);
      setFullName("");
      setEmail("");
      setSubject("");
      setMessage("");
    } else {
      console.log("Submitted Invalid Form");
    }
  };

  return (
    <>
      <CssBaseline />
      <Container maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Contact Us
          </Typography>
          <Box
            component="form"
            onSubmit={onFormSubmit}
            noValidate
            sx={{ mt: 1, width: { xs: "20rem", md: "30rem" } }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="name"
              label="Full Name"
              name="name"
              value={fullName}
              onChange={onFullNameChange}
            />
            <Box color={"red"}>
              <p>{fullNameError}</p>
            </Box>

            <TextField
              margin="normal"
              required
              fullWidth
              id="subject"
              label="Subject"
              name="subject"
              value={subject}
              onChange={onSubjectChange}
            />
            <Box color={"red"}>
              <p>{subjectError}</p>
            </Box>

            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              value={email}
              onChange={onEmailChange}
            />
            <Box color={"red"}>
              <p>{emailError}</p>
            </Box>

            <TextField
              margin="normal"
              required
              fullWidth
              name="message"
              label="Message"
              id="message"
              value={message}
              onChange={onMessageChange}
            />
            <Box color={"red"}>
              <p>{messageError}</p>
            </Box>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              sx={{ mt: 5, mb: 15 }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
}
